import envConfig from "env-config";

export const remoteStaticPath = `https://${envConfig.REACT_APP_STATIC_BASE_URL}/SectionImages/svgIcons`;

export const getIconUrl = (icon: string) => {
  const iconURL = /.svg/.test(icon) ? `${remoteStaticPath}/${icon}` : icon;

  return iconURL;
};
